function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3338 8.66667H12.0005V6C12.0005 3.4 9.93382 1.33333 7.33382 1.33333C4.73382 1.33333 2.66715 3.4 2.66715 6V8.66667H1.33382V6C1.33382 2.66667 4.00049 0 7.33382 0C10.6672 0 13.3338 2.66667 13.3338 6V8.66667Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6667 20H2C0.866667 20 0 19.1333 0 18V10C0 8.86667 0.866667 8 2 8H12.6667C13.8 8 14.6667 8.86667 14.6667 10V18C14.6667 19.1333 13.8 20 12.6667 20ZM2 9.33333C1.6 9.33333 1.33333 9.6 1.33333 10V18C1.33333 18.4 1.6 18.6667 2 18.6667H12.6667C13.0667 18.6667 13.3333 18.4 13.3333 18V10C13.3333 9.6 13.0667 9.33333 12.6667 9.33333H2Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.33333 13.3334C8.06971 13.3334 8.66667 12.7365 8.66667 12.0001C8.66667 11.2637 8.06971 10.6667 7.33333 10.6667C6.59695 10.6667 6 11.2637 6 12.0001C6 12.7365 6.59695 13.3334 7.33333 13.3334Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.66536 12H6.9987L6.33203 16H8.33203L7.66536 12Z"
});

var SvgPasswordIcon = function SvgPasswordIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPasswordIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password-icon.4ecea6fb.svg";
export { ForwardRef as ReactComponent };